import { TransactionLinkType } from "@bitwarden/web-vault/app/models/types/transaction.types";

// Shared display mapping for a transaction link type. `LinkTypeBadgeComponent`
// (<app-link-type-badge>) is now the single consumer — it derives the icon/label
// here so every call site renders the pill identically.

// Sprite icon id per link type — `link` (chain) reads as "paired",
// `coins-swap` as "converted between symbols". Exhaustive by construction: a new
// `TransactionLinkType` member fails to compile here until it's mapped.
const LINK_TYPE_ICONS: Record<TransactionLinkType, string> = {
  transfer: "link",
  conversion: "coins-swap",
};

export function linkTypeIcon(linkType: TransactionLinkType): string {
  return LINK_TYPE_ICONS[linkType];
}

// Human label per link type (hardcoded, no i18n — kept in lockstep with the
// desc-renderer, which is also un-i18n'd).
const LINK_TYPE_LABELS: Record<TransactionLinkType, string> = {
  transfer: "Transfer",
  conversion: "Conversion",
};

export function linkTypeLabel(linkType: TransactionLinkType): string {
  return LINK_TYPE_LABELS[linkType];
}
